import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { TablePage } from './pages/TablePage';
import { HomePage } from './pages/HomePage';
import { AdventureDetailPage } from './pages/AdventureDetailPage';
import { RunsPage } from './pages/RunsPage';
import { PeoplePage } from './pages/PeoplePage';
import { GroupsPage } from './pages/GroupsPage';
import { GroupDetailPage } from './pages/GroupDetailPage';
import { BookingPage } from './pages/BookingPage';
import { PlayerDisplayPage } from './pages/PlayerDisplayPage';
import { BinderLayout } from './components/layout/BinderLayout';
import { SectionRouter, BinderIndexRedirect } from './components/layout/SectionRouter';
import { EditorLayout, SectionsPage, EntityListPage, EntityEditPage } from './pages/editor';
import { ToastHost } from './components/ui';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TablePage />} />
        <Route path="/library" element={<HomePage />} />
        <Route path="/library/:slug" element={<AdventureDetailPage />} />
        <Route path="/library/:slug/edit" element={<EditorLayout />}>
          <Route index element={<SectionsPage />} />
          <Route path=":sectionId" element={<EntityListPage />} />
          <Route path=":sectionId/:entityId" element={<EntityEditPage />} />
        </Route>
        <Route path="/groups" element={<GroupsPage />} />
        <Route path="/groups/:id" element={<GroupDetailPage />} />
        <Route path="/runs" element={<RunsPage />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/dashboard" element={<Navigate to="/" replace />} />
        <Route path="/book/:token" element={<BookingPage />} />
        <Route path="/display" element={<PlayerDisplayPage />} />

        <Route path="/run/:instanceId" element={<BinderLayout />}>
          <Route index element={<BinderIndexRedirect />} />
          <Route path=":sectionId" element={<SectionRouter />} />
          <Route path=":sectionId/:entityId" element={<SectionRouter />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastHost />
    </BrowserRouter>
  );
}
